type FormProps = {
  $hasDestinationInput: boolean;
  $hasMoreOptionsToggle: boolean;
  $hasLocationError: boolean;
  $hasDateError: boolean;
};

const joinAreas = (areas: string[]) => areas.filter(Boolean).join('\n');

export const getDefaultGridTemplateAreas = ({
  $hasDestinationInput,
  $hasMoreOptionsToggle,
  $hasLocationError,
  $hasDateError,
}: FormProps) =>
  joinAreas([
    "'departure'",
    $hasDestinationInput ? "'destination'" : '',
    $hasLocationError ? "'location-error'" : '',
    "'one-way-toggle'",
    "'date-picker'",
    "'time-picker'",
    $hasDateError ? "'date-error'" : '',
    "'age'",
    "'button'",
    $hasMoreOptionsToggle ? "'options-toggle'" : '',
  ]);

export const getDefaultWideGridTemplateAreas = ({
  $hasDestinationInput,
  $hasMoreOptionsToggle,
  $hasLocationError,
  $hasDateError,
}: FormProps) =>
  joinAreas([
    `'departure ${$hasDestinationInput ? 'destination' : 'departure'}'`,
    $hasLocationError ? "'location-error location-error'" : '',
    "'one-way-toggle one-way-toggle'",
    "'date-picker date-picker'",
    "'time-picker time-picker'",
    $hasDateError ? "'date-error date-error'" : '',
    "'age age'",
    "'button button'",
    $hasMoreOptionsToggle ? "'options-toggle options-toggle'" : '',
  ]);

export const getMediumGridTemplateAreas = ({
  $hasDestinationInput,
  $hasMoreOptionsToggle,
  $hasLocationError,
  $hasDateError,
}: FormProps) =>
  joinAreas([
    `'departure ${$hasDestinationInput ? 'destination' : 'departure'}'`,
    $hasLocationError ? "'location-error location-error'" : '',
    "'one-way-toggle one-way-toggle'",
    "'date-picker time-picker'",
    $hasDateError ? "'date-error date-error'" : '',
    "'age button'",
    $hasMoreOptionsToggle ? "'options-toggle options-toggle'" : '',
  ]);

export const getLargeGridTemplateAreas = ({
  $hasDestinationInput,
  $hasMoreOptionsToggle,
  $hasLocationError,
  $hasDateError,
}: FormProps) =>
  joinAreas([
    `'departure ${$hasDestinationInput ? 'destination' : 'departure'} date-picker time-picker'`,
    $hasLocationError || $hasDateError
      ? "'location-error location-error date-error date-error'"
      : '',
    "'one-way-toggle one-way-toggle age button'",
    $hasMoreOptionsToggle ? "'. . . options-toggle'" : '',
  ]);

export const getExtraLargeGridTemplateAreas = ({
  $hasDestinationInput,
  $hasMoreOptionsToggle,
  $hasLocationError,
  $hasDateError,
}: FormProps) =>
  joinAreas([
    `'departure ${$hasDestinationInput ? 'destination' : 'departure'} date-picker time-picker'`,
    $hasLocationError || $hasDateError
      ? "'location-error location-error date-error date-error'"
      : '',
    "'one-way-toggle age . button'",
    $hasMoreOptionsToggle ? "'. . . options-toggle'" : '',
  ]);
